import * as React from "react";

import FileExtensionsInput from "../common/FileExtensionsInput";
import OutlinedDiv from "../common/OutlinedDiv";

interface FileExtensionsFlagInputProps {
  extensionFlags: string[];
  onChange: (value: string[]) => void;
  disabled?: boolean;
}
const FileExtensionsFlagInput: React.FC<FileExtensionsFlagInputProps> = ({
  extensionFlags,
  onChange,
  disabled = false,
}) => {
  return (
    <OutlinedDiv label="File Extension Flags" disabled={disabled}>
      <FileExtensionsInput
        placeholder="Add extension"
        extensions={extensionFlags}
        onExtensionsChange={onChange}
        disabled={disabled}
      />
    </OutlinedDiv>
  );
};

export default FileExtensionsFlagInput;
